/**
 * 大江看看APP工具类
 */
import { localget } from './storage';
import consts from 'Utils/consts';


/**
 * 是否是大江看看APP
 * @return {boolean}
 */
export function isDjkk() {
  const channelParam = localget(consts.thirdChannelParam);
  return channelParam && 'djkk' === channelParam.accessChannel;
}
